module.exports = __webpack_public_path__ + "static/week_grid_with_task_list-7a9725461604acf821e83496026dacfb.png";